import { Vector3 } from "three";
import * as THREE from "three";
import { OrbitControls } from "./ModifiedOrbitControls";
export class Camera {
    constructor(scene) {
        this.scene = scene;
        this.formData = this.scene.formData;
        this.createCamera();
    }
    createCamera() {
        this.width = this.formData.widthValue;
        this.projection = this.formData.projectionValue;
        this.threeCamera = new THREE.PerspectiveCamera(45, this.aspectRatio(), 1, 10000);
        // Enable layers for the post processing
        this.threeCamera.layers.enable(1);
        this.controls = new OrbitControls(this.threeCamera, this.scene.renderer.domElement);
        // Right click control
        this.controls.enablePan = false;
        // Contols the vertical angle of the camera rotation
        this.controls.minPolarAngle = 0;
        this.controls.maxPolarAngle = Math.PI / 2;
        const rotated = this.formData.measuredModel.rotated;
        const projectWidth = rotated ? this.formData.projectionValue : this.formData.widthValue;
        const projectProjection = rotated ? this.formData.widthValue : this.formData.projectionValue;
        const modulesX = this.formData.measuredModel.modulesX;
        const modulesZ = this.formData.measuredModel.modulesZ;
        //this.controls.enableZoom = false
        const wallDepth = 30;
        const groundProjection = projectProjection + wallDepth * 2 + this.formData.measuredModel.model.edgeWidth - ((modulesX - 1) * this.formData.measuredModel.model.edgeWidth);
        const groundWidth = projectWidth + wallDepth * 2 - ((modulesZ - 1) * this.formData.measuredModel.model.edgeWidth);
        //CAMERA
        let cameraPosition;
        if (rotated) {
            cameraPosition = new Vector3(-this.formData.measuredModel.projection - 400 - (modulesX - 1) * 250, 500, this.formData.measuredModel.width + this.formData.measuredModel.width / 2 + (modulesZ - 1) * 450);
        }
        else {
            cameraPosition = new Vector3(groundProjection + (modulesZ - 1) * 150, 500, groundWidth + 250 + (modulesX - 1) * 150);
        }
        this.setCameraPosition(cameraPosition);
        const target = new Vector3().copy(this.scene.dimensions.centerPos);
        target.y += 30;
        this.setCameraTarget(target);
        this.controls.update();
    }
    updateCamPos(data) {
        if (data.widthValue !== this.width || data.projectionValue !== this.projection) {
            this.width = data.widthValue;
            this.projection = data.projectionValue;
            const target = new Vector3().copy(this.scene.dimensions.centerPos);
            target.y += 30;
            const rotated = data.measuredModel.rotated;
            const projectWidth = rotated ? data.projectionValue : data.widthValue;
            const projectProjection = rotated ? this.formData.widthValue : data.projectionValue;
            const modulesX = data.measuredModel.modulesX;
            const modulesZ = data.measuredModel.modulesZ;
            const wallDepth = 30;
            const groundProjection = projectProjection + wallDepth * 2 + data.measuredModel.model.edgeWidth - ((modulesX - 1) * data.measuredModel.model.edgeWidth);
            const groundWidth = projectWidth + wallDepth * 2 - ((modulesZ - 1) * data.measuredModel.model.edgeWidth);
            //CAMERA
            let cameraPosition;
            if (rotated) {
                cameraPosition = new Vector3(-data.measuredModel.projection - 400 - (modulesX - 1) * 250, 500, data.measuredModel.width + data.measuredModel.width / 2 + (modulesZ - 1) * 450);
            }
            else {
                cameraPosition = new Vector3(groundProjection + (modulesZ - 1) * 150, 500, groundWidth + 250 + (modulesX - 1) * 150);
            }
            this.setCameraPosition(cameraPosition);
            this.threeCamera.updateProjectionMatrix();
            this.setCameraTarget(target);
            this.controls.update();
        }
    }
    setCameraTarget(target) {
        this.controls.target = target;
    }
    setCameraPosition(target) {
        this.threeCamera.position.set(target.x, target.y, target.z);
    }
    setCameraFreeRotation(enabled) {
        this.controls.enabled = enabled;
    }
    resize() {
        this.threeCamera.aspect = this.aspectRatio();
        this.threeCamera.updateProjectionMatrix();
    }
    /*  moveCameraFocusWidth(focus: boolean, width: number, projection:number) {
          this.moveCamera(focus ? new Vector2( width / 4 , projection / 4 ) : new Vector2(1000, 1000))
      }
  
      moveCameraFocusProjection(focus: boolean, width: number, projection:number) {
          this.moveCamera(focus ? new Vector2( width / 4 , projection / 4 ) : new Vector2(1000, 1000))
      }
  
      moveCamera(pos: THREE.Vector2) {
          const cam = this.threeCamera
  
          new TWEEN.Tween(cam.position)
              .to({ x: pos.x, z: pos.y }, 1000)
              .easing(TWEEN.Easing.Quadratic.In)
              .onUpdate(function (coord) {
                  cam.position.set(coord.x, 300, coord.z);
              })
              .start();
      }*/
    aspectRatio() {
        const canvas = this.scene.renderer.domElement;
        return canvas.clientWidth / canvas.clientHeight;
    }
}
